import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {connect} from 'react-redux'
import NotificationTypeSelector from './NotificationTypeSelector'
import NotificationsEmpty from './NotificationsEmpty'

export class NotificationList extends React.Component {
  render() {
    const {read, unread, maxItemCount, markOneAsRead, markAsUnread} = this.props
    const showUnreadNotifications = unread.length > 0
    const showReadNotifications = read.length > 0 && unread.length < maxItemCount
    if (!showReadNotifications && !showUnreadNotifications) {
      return <NotificationsEmpty />
    }
    const readCount = Math.max(maxItemCount - unread.length, 0)

    return (
      <div className="notificationList">
        {showUnreadNotifications && (
          <div className="notificationList__unread" data-testid="notificationslist-unread">
            <div className="notificationList__unreadText">{i18n.t('notification_unread')}</div>
            {unread.slice(0, maxItemCount).map(un => (
              <NotificationTypeSelector {...un} key={un.id} markAsRead={markOneAsRead} markAsUnread={markAsUnread} />
            ))}
          </div>
        )}
        {showReadNotifications && (
          <div className="notificationList__read" data-testid="notificationslist-read">
            <div className="notificationList__readText">{i18n.t('notification_read')}</div>
            {read.slice(0, readCount).map(rn => (
              <NotificationTypeSelector {...rn} key={rn.id} markAsRead={markOneAsRead} markAsUnread={markAsUnread} />
            ))}
          </div>
        )}
      </div>
    )
  }
}

NotificationList.defaultProps = {
  maxItemCount: 5,
}

NotificationList.propTypes = {
  read: PropTypes.array.isRequired,
  unread: PropTypes.array.isRequired,
  maxItemCount: PropTypes.number,
  markOneAsRead: PropTypes.func,
  markAsUnread: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    read: state.benachrichtigungen.read,
    unread: state.benachrichtigungen.unread,
  }
}

export default connect(mapStateToProps)(NotificationList)
